// ------SAMPLE CALLS------

import {
  getBranch,
  getKey,
  getToken,
  getUser,
} from "../../../Components/Helpers/Utilities/Common";
import {
  getAPICall,
  postAPICallwithFile,
  putAPICall,
  postAPICall,
  getWithParamsAPICall,
} from "../../../Components/Helpers/API/axiosMethodCall";

//POST API -- append a new data to the db
export const loginUser = async (username, password, branch_code) => {
  try {
    const response = await postAPICall(process.env.REACT_APP_LINK + "login", {
      branch_code: branch_code,
      username: username,
      password: password,
    });
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const logout = async () => {
  try {
    const response = await postAPICall(process.env.REACT_APP_LINK + "logout", {
      token: getToken(),
      requester: getUser(),
    });
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
